import * as React from 'react';
import { useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useEndedEventIds, useJoinableEventIds } from '../../api/event';
import {
  useEndedTrainingIds,
  useJoinableTrainingIds,
} from '../../api/training';
import { useCurrentUser } from '../../redux/selectors/authSelectors';
import PlayerImg from '../../static/svg/MyPage_Player.svg';
import EventTrainingTable from '../trainingProvider/EventTrainingTable';
import CommonBG from '../uiElements/CommonBG';

interface EventsTrainingsProps {}
const EventsTrainings: React.FC<EventsTrainingsProps> = () => {
  const user = useCurrentUser();
  const navigate = useNavigate();

  const onEventJoin = (eventId?: string) => {
    navigate(`/events/${eventId}/information`);
  };

  const onTrainingJoin = (trainingId?: string) => {
    navigate(`/trainings/${trainingId}/stages`);
  };

  const [eventIds, loading] = useJoinableEventIds(user);
  const [endedIds, loading2] = useEndedEventIds(user);
  const [trainingIds, loading3] = useJoinableTrainingIds(user);
  const [endedTrainingIds, loading4] = useEndedTrainingIds(user);

  const availableIds = useMemo(() => {
    if (!endedIds) {
      return eventIds;
    }
    return eventIds?.filter(e => !endedIds.includes(e)) ?? [];
  }, [eventIds, endedIds]);

  const availableTrainingIds = useMemo(() => {
    if (!endedTrainingIds) {
      return trainingIds;
    }
    return trainingIds?.filter(e => !endedTrainingIds.includes(e)) ?? [];
  }, [trainingIds, endedTrainingIds]);

  return (
    <CommonBG withHeader withFooter headerOptions={{ buttonType: 'logout' }}>
      <EventsTrainingsWrapper>
        <Content>
          <Player>
            <SVG src={PlayerImg} />
            <p>{user?.displayName ?? 'NoName'}</p>
          </Player>

          <EventTrainingTable
            eventIds={availableIds ?? []}
            trainingIds={availableTrainingIds ?? []}
            type='eventsTrainingsView'
            onEventJoin={onEventJoin}
            onTrainingJoin={onTrainingJoin}
          />
          {(loading || loading2 || loading3 || loading4) && (
            <Loading>Loading...</Loading>
          )}
        </Content>
      </EventsTrainingsWrapper>
    </CommonBG>
  );
};

const EventsTrainingsWrapper = styled.div``;

const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2.4rem 8rem 0;
`;

const Player = styled.div`
  display: flex;
  align-items: center;
  height: 7rem;
  line-height: 7rem;
  font-size: 2.8rem;
  margin: 0 auto;

  p {
    font-weight: bold;
  }

  svg {
    width: 4rem;
    height: 4rem;
    margin-right: 4rem;
  }
`;

const Loading = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  padding: 1rem 0;
`;

export default EventsTrainings;
